import styled from 'styled-components';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var SelectOptionSeparator = styled.div.attrs({
  className: 'gz-select__separator',
  'aria-hidden': true
}).withConfig({
  componentId: "gz-select-1679042064662__sc-hogovm-0"
})(["background-color:#ccc;height:1px;margin:4px 0;width:100%;"]);
SelectOptionSeparator.COMPONENT_ID = 'Gearz.Select.Separator';
SelectOptionSeparator.displayName = SelectOptionSeparator.COMPONENT_ID;

export { SelectOptionSeparator as S };
